<template>
  <div>
    <v-img
      contain
      :width="imageSize"
      :loading="loading"
      :src="imageData?.path || ''"
      :alt="imageData?.name || ''"
      lazy-src="@/assets/img/placeholders/loading.svg"
    >
      <template #placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="#db0218" />
        </v-row>
      </template>
    </v-img>
  </div>
</template>
<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import { getProductMainImage } from '@/repositories/ProductFiles';

  export default {
    name: 'MaterialImage',

    props: {
      code: {
        type: [String, Number],
        required: String,
      },

      size: {
        type: String,
        default: '75px',
      },

      xs: Boolean,
      sm: Boolean,
      md: Boolean,
      lg: Boolean,
    },

    data() {
      return {
        imageData: null,
        loading: false,
      };
    },

    computed: {
      imageSize() {
        if (this.xs) return '65px';
        if (this.sm) return '75px';
        if (this.md) return '90px';
        if (this.lg) return '105px';

        return this.size;
      },
    },

    watch: {
      code() {
        this.loadImage();
      },
    },

    async mounted() {
      this.loadImage();
    },

    methods: {
      async loadImage() {
        this.loading = true;

        const { image } = await getProductMainImage(this.code);
        this.imageData = image;

        this.loading = false;
      },
    },
  };
</script>
